import { useEffect, useState, useRef } from "react";
import { Button, Divider, Grid, Image, ImageViewer, Swiper } from "antd-mobile";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
// import QRCode from 'qrcode.react';
import "./index.scss";
import r, { api } from "modules/Request";
import { useBoolean } from "hooks";
import MobileTable from "./MobileTable";
import classnames from "classnames";

import TYPE_ICON from "./images/type_icon.png";
import MODEL_ICON from "./images/model_icon.png";
import WEIGHT_ICON from "./images/weight_icon.png";
import R_ICON from "./images/r_icon.png";
import RZ_ICON from "./images/rz_icon.png";
import DC_ICON from "./images/dc_icon.png";
import ARROW_ICON from "./images/arrow_icon.png";
import ZJ_ICON from "./images/zj_icon.png";
import YCL_ICON from "./images/ycl_icon.png";
import SC_ICON from "./images/sc_icon.png";
import FX_ICON from "./images/fx_icon.png";
import MQ_ICON from "./images/mq_icon.png";
import LOGOICON from "./../../DataCenter/images/logo.png";
import batteryPassportTranslate from "i18nData/batteryPassportTranslate";

export default function BatteryPassport() {
  const [resData, setResData] = useState([]);
  const [headerData, setHeaderData] = useState([]); //数字电子护照头vo
  const [commonData, setCommonData] = useState([]); //电池一般信息vo
  const [rawData, setRawData] = useState([]); //电池原材料信息vo
  const [relatedData, setRelatedData] = useState([]); //电池ESG相关信息vo
  const [declarationOfEUImgList, setDeclarationOfEUImgList] = useState([]); //电池ESG相关信息vo
  const [chainListData, setChainListData] = useState([]); //供应链数据追溯vo
  const [open, { toggle }] = useBoolean(); //查看更多开关
  const [rawOpen, { toggle: rawOpenTag }] = useBoolean(); //废电池管理说明开关
  const [modalData, setModalData] = useState({
    open: false,
    imgList: [],
  });
  const getPathname = window.location.pathname;
  let languageEn = "/batteryPassportEn".indexOf(getPathname) !== -1; //英文TRUE
  const codeUrl =
    window.location.origin +
    (languageEn ? "/batteryPassportEn" : "batteryPassportCh");
  const [responseIndex, setResponseIndex] = useState(0);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [responseOpen, setResponseOpen] = useState(false);
  //获取中英文
  const dictionariesData = batteryPassportTranslate(languageEn);
  document.title = dictionariesData.DigitalBatteryPassport;
  const handleOpenLightbox = () => {
    setIsOpen(true);
  };

  const handleCloseLightbox = () => {
    setIsOpen(false);
  };

  const handlePrevImage = () => {
    setPhotoIndex(
      (prevIndex) =>
        (prevIndex + relatedData?.responseProcurementImgList.length - 1) %
        relatedData?.responseProcurementImgList.length
    );
  };
  const handleNextImage = () => {
    setPhotoIndex(
      (prevIndex) =>
        (prevIndex + 1) % relatedData?.responseProcurementImgList.length
    );
  };
  const responseNextImage = () => {
    setPhotoIndex(
      (prevIndex) => (prevIndex + 1) % declarationOfEUImgList.length
    );
  };
  const handleResponsePrevImage = () => {
    setResponseIndex(
      (prevIndex) =>
        (prevIndex + declarationOfEUImgList.length - 1) %
        declarationOfEUImgList.length
    );
  };
  // \n转p
  function parseStringWithLineBreaks(str) {
    const lines = str.split("\n");
    let result = "";

    for (let i = 0; i < lines.length; i++) {
      if (lines[i].trim() !== "") {
        result += `<p>${lines[i]}</p>`;
      }
    }

    return result;
  }

  const columns = [
    {
      title: dictionariesData["Product Name"],
      dataIndex: "productName",
      width: "2.3rem",
      left: 0,
    },
    {
      title: dictionariesData["Carbon Emission"] + "\n(kg CO₂e)",
      dataIndex: "carbon",
      fixed: "left",
      width: "1.96rem",
      left: "2.3rem",
    },
  ];
  const columnsTwo = [
    {
      title: dictionariesData["Carbon Footprint"],
      dataIndex: "dataType",
      width: languageEn ? "3.2rem" : "2.6rem",
    },
    {
      title: dictionariesData["Responsible Sourcing"],
      dataIndex: "responseProcurement",
      width: "2.1rem",
    },
    {
      title: dictionariesData["Manufacturer"],
      dataIndex: "producer",
      width: "2.5rem",
    },
    { title: dictionariesData["Manufacturing Date"], dataIndex: "produceDate" },
  ];
  useEffect(() => {
    getFillReviewFn();
  }, []);
  const getFillReviewFn = async () => {
    try {
      // let res = await r.get(api.GET_FILLRE_VIEW + 'xqilg1ut1');
      let res = await r.get(
        languageEn ? api.FUXI_V8_DIGITAL_ELE_EN : api.FUXI_V8_DIGITAL_ELE_CH
      );
      if (res.status.code === "00000") {
        let resData = res.data;
        setResData(resData);
        setHeaderData(resData?.header);
        setCommonData(resData?.common);
        setRawData(resData?.raw);
        setRelatedData(resData?.related);
        setDeclarationOfEUImgList(resData?.related?.declarationOfEUImgList);
        setChainListData(resData?.chainList);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const blockchain = headerData?.blockchain;
  // 区块链存证
  const blockchainOmit = blockchain
    ? blockchain.substring(0, languageEn ? 9 : 16) +
      "..." +
      blockchain.substring(languageEn ? 30 : 28)
    : "--";

  return (
    <div className="battery_passport">
      {isOpen && (
        <Lightbox
          mainSrc={relatedData?.responseProcurementImgList[photoIndex]}
          onCloseRequest={handleCloseLightbox}
          onMovePrevRequest={handlePrevImage}
          onMoveNextRequest={handleNextImage}
        />
      )}
      {responseOpen && (
        <Lightbox
          mainSrc={declarationOfEUImgList[responseIndex]}
          onCloseRequest={() => {
            setResponseOpen(false);
          }}
          onMovePrevRequest={handleResponsePrevImage}
          onMoveNextRequest={responseNextImage}
        />
      )}
      {/* <div id="getCode">
                <QRCode
                    value={codeUrl}
                    renderAs="canvas"
                    imageSettings={{
                        src: mq_icon,
                        x: undefined,
                        y: undefined,
                        height: 20,
                        width: 20,
                        excavate: true,
                    }}
                />
            </div> */}
      <div className="battery_qrcode">
        <Image
          className="qrcode-img"
          src={headerData?.qrCodeImg}
          alt="qrcode"
        />
      </div>
      <div className="battery_passport_header">
        <div className="battery_passport_header_margin">
          <div className="battery_passport_header_flex">
            <div className="green_swiper_bor battery_passport_swiper">
              <div className="swiper_box">
                <Image
                  height="3.28rem"
                  fit="contain"
                  src={headerData?.batteryImgList?.[0]}
                />
              </div>
              {/* <Swiper>
                {headerData?.batteryImgList?.map((item, index) => {
                  return (
                    <Swiper.Item key={index}>
                      
                    </Swiper.Item>
                  );
                })}
              </Swiper> */}
            </div>
            <div className="battery_passport_header_right_box">
              <p className="passport_header_title">
                {dictionariesData.UniqueIdentifier}
              </p>
              <p className="passport_header_code mt-11r">
                {headerData?.batteryIDCode}
              </p>
              <div className="passport_blockchain_box">
                <div className="passport_blockchain_title_box">
                  <p className="passport_blockchain_title">
                    {dictionariesData.GenerationTime}
                  </p>
                  <p className="passport_blockchain_value">
                    {headerData?.generateTime}
                  </p>
                </div>
                <div className="passport_blockchain_title_box mt-11r">
                  <p className="passport_blockchain_title">
                    {dictionariesData.BlockchainNotarization}
                  </p>
                  <p className="passport_blockchain_value">{blockchainOmit}</p>
                </div>
              </div>
            </div>
          </div>
          <Grid
            className="battery_classify_box"
            columns={languageEn ? 4 : 3}
            gap={8}
          >
            <Grid.Item>
              <div className="battery_classify">
                <img
                  className="battery_classify_img"
                  alt="img"
                  src={TYPE_ICON}
                />
                <div className="battery_classify_title">
                  {dictionariesData.Classification}
                </div>
                <div className="battery_classify_value">
                  {headerData?.batteryType}
                </div>
              </div>
            </Grid.Item>
            <Grid.Item span={languageEn ? 2 : 1}>
              <div className="battery_classify">
                <img
                  className="battery_classify_img"
                  alt="img"
                  src={MODEL_ICON}
                />
                <div className="battery_classify_title">
                  {dictionariesData.ModelIdentification}
                </div>
                <div className="battery_classify_value">
                  {headerData?.batteryModel}
                </div>
              </div>
            </Grid.Item>
            <Grid.Item>
              <div className="battery_classify">
                <img
                  className="battery_classify_img"
                  alt="img"
                  src={WEIGHT_ICON}
                />
                <div className="battery_classify_title">
                  {dictionariesData.Weight} (kg)
                </div>
                <div className="battery_classify_value">
                  {headerData?.batteryWeight}
                </div>
              </div>
            </Grid.Item>
          </Grid>
        </div>
      </div>
      <div className="battery_passport_message_box">
        <div className="battery_passport_message_margin">
          <div className="battery_passport_message">
            {dictionariesData["General Information on Batteriesy"]}
          </div>
          <div className="battery_passport_message_underline"></div>
          <div className="battery_passport_white">
            <Grid columns={2} gap={0}>
              <Grid.Item>
                <div className="battery_passport_message_title">
                  <img
                    alt="img"
                    src={R_ICON}
                    className="battery_passport_mini_icon "
                  />
                  {dictionariesData.RegisteredTradeMark}
                </div>
                <img
                  alt="img"
                  src={commonData?.registeredTrademarkImg}
                  className="battery_passport_brand_size"
                />
                <div className="battery_passport_message_title">
                  <img
                    alt="img"
                    src={RZ_ICON}
                    className="battery_passport_mini_icon "
                  />
                  {dictionariesData.SeparateCollection}
                </div>
                <img
                  alt="img"
                  src={commonData?.certClassifyImg}
                  className="battery_passport_classify_size mt-11r"
                />
                <div className="battery_passport_message_title">
                  <img
                    alt="img"
                    src={DC_ICON}
                    className="battery_passport_mini_icon "
                  />
                  {dictionariesData.Capacity}
                </div>
                <p className="battery_capacity_value">
                  {commonData?.batteryCapacity}
                  <span className="battery_passport_message_value ml-11r">
                    {commonData?.batteryCapacityUnit}
                  </span>
                </p>
              </Grid.Item>
              <Grid.Item>
                <div>
                  <p className="battery_passport_message_title">
                    {dictionariesData.RegisteredTradeName}
                  </p>
                  <p className="battery_passport_message_value">
                    {commonData?.registeredName}
                  </p>
                </div>
                <div className="mt-32r">
                  <p className="battery_passport_message_title">
                    {dictionariesData["Non-rechargeable"]}
                  </p>
                  <p className="battery_passport_message_value">
                    {commonData?.chargeFlag}
                  </p>
                </div>
                <div className="mt-32r">
                  <p className="battery_passport_message_title">
                    {dictionariesData.UsableExtinguishingAgent}
                  </p>
                  <p className="battery_passport_message_value">
                    {commonData?.availableFireExtinguisher}
                  </p>
                </div>
                <div className="mt-32r">
                  <p className="battery_passport_message_title">
                    {dictionariesData.Chemistry}
                  </p>
                  <p className="battery_passport_message_value">
                    {commonData?.chemicalProperty}
                  </p>
                </div>
                <div className="mt-32r">
                  <p className="battery_passport_message_title">
                    {dictionariesData["Hazardous Substance"]}
                  </p>
                  <p className="battery_passport_message_value">
                    {commonData?.hazardousSubstances}
                  </p>
                </div>
              </Grid.Item>
            </Grid>
            <div className="battery_passport_view_more">
              <span>{dictionariesData["View More Information"]}</span>
              <img
                onClick={() => {
                  toggle();
                }}
                alt="img"
                src={ARROW_ICON}
                className={classnames("battery_passport_view_more_arrow", {
                  rotate180deg: open,
                })}
              />
            </div>
            {open && (
              <div className="">
                <div className="hide_battery_passport_view_more">
                  <div className="hide_battery_passport_view_more_message">
                    <div className="hide_battery_passport_view_more_flex">
                      <p className="battery_passport_message_title">
                        {dictionariesData["Batch Number"]}
                      </p>
                      <p className="battery_passport_message_value">
                        {commonData?.produceBatchNo}
                      </p>
                    </div>
                    <div className="hide_battery_passport_view_more_flex">
                      <p className="battery_passport_message_title">
                        {dictionariesData["Manufacturing Date"]}
                      </p>
                      <p className="battery_passport_message_value">
                        {commonData?.produceDate}
                      </p>
                    </div>
                  </div>
                  <div className="hide_battery_passport_view_more_message">
                    <div className="hide_battery_passport_view_more_flex">
                      <p className="battery_passport_message_title">
                        {dictionariesData["Manufacturer Name"]}
                      </p>
                      <p className="battery_passport_message_value">
                        {commonData?.producer}
                      </p>
                    </div>
                    <div className="hide_battery_passport_view_more_flex">
                      <p className="battery_passport_message_title">
                        {dictionariesData["Manufacturing Address"]}
                      </p>
                      <p className="battery_passport_message_value">
                        {commonData?.produceAddress}
                      </p>
                    </div>
                  </div>
                  <div className="hide_battery_passport_view_more_message">
                    <div className="hide_battery_passport_view_more_flex">
                      <p className="battery_passport_message_title">
                        {dictionariesData["Manufacturer Email Address"]}
                      </p>
                      <p className="battery_passport_message_value">
                        {commonData?.contactInfo}
                      </p>
                    </div>
                    <div className="hide_battery_passport_view_more_flex">
                      <p className="battery_passport_message_title">
                        {dictionariesData["Manufacturer Postal Address"]}
                      </p>
                      <p className="battery_passport_message_value">
                        {commonData?.manufacturerAddress}
                      </p>
                    </div>
                  </div>
                  <div className="hide_battery_passport_view_more_message">
                    <div className="hide_battery_passport_view_more_flex">
                      <p className="battery_passport_message_title">
                        {dictionariesData["Manufacturer Web"]}
                      </p>
                      <p className="battery_passport_message_value">
                        {commonData?.manufacturerWebsite}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="battery_passport_table_box">
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Battery Carbon Footprint Units"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.carbonUnit}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Carbon Footprint Performance Class"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.performanceLevel}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Critical Raw Materials"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.keyRawMaterials}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["C-rate of Relevant"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div
                        className="battery_passport_table_right"
                        dangerouslySetInnerHTML={{
                          __html: parseStringWithLineBreaks(
                            commonData?.lifeTest
                          ),
                        }}
                      >
                        {/* {commonData?.lifeTest} */}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Capacity Threshold for Exhaustion"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.capacityThreshold}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {
                          dictionariesData[
                            "Temperature Range (when not in use)"
                          ]
                        }
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div
                        className="battery_passport_table_right"
                        dangerouslySetInnerHTML={{
                          __html: parseStringWithLineBreaks(
                            commonData?.temperatureRange
                          ),
                        }}
                      ></div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {
                          dictionariesData[
                            "Expected Lifetime (expressed in cycles)"
                          ]
                        }
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.lifeExpectancy}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Rated Capacity (in Ah)"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.ratedCapacity}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Power Capability"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.powerCapacity}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Commercial Warranty Period"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.commercialWarrantyPeriod}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Round Trip Energy Efficiency"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.energyEfficiency}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_table_flex">
                    <div className="battery_passport_table_left_box">
                      <div className="battery_passport_table_left">
                        {dictionariesData["Internal Resistance"]}
                      </div>
                    </div>
                    <div className="battery_passport_table_right_box">
                      <div className="battery_passport_table_right">
                        {commonData?.batteryCell}
                      </div>
                    </div>
                  </div>
                  <div className="battery_passport_quartering_box">
                    <div className="battery_passport_quartering battery_voltage">
                      {dictionariesData["Voltage"]}
                    </div>
                    <div className="battery_passport_quartering">
                      <p>
                        {dictionariesData["Nominal Voltage"]}
                        <br />
                        {commonData?.ratedVoltage}
                      </p>
                      <p className="voltage_min_height">
                        {dictionariesData["Temperature Range"]}
                        <br />
                        {commonData?.ratedVoltageTemperature}
                      </p>
                    </div>
                    <div className="battery_passport_quartering">
                      <p>
                        {dictionariesData["Minimal Voltage"]}
                        <br />
                        {commonData?.minVoltage}
                      </p>
                      <p className="voltage_min_height">
                        {dictionariesData["Temperature Range"]}
                        <br />
                        {commonData?.minVoltageTemperature}
                      </p>
                    </div>
                    <div className="battery_passport_quartering">
                      <p>
                        {dictionariesData["Maximum Voltage"]}
                        <br />
                        {commonData?.maxVoltage}
                      </p>
                      <p className="voltage_min_height">
                        {dictionariesData["Temperature Range"]}
                        <br />
                        {commonData?.maxVoltageTemperature}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div
        className="battery_passport_raw_material_box"
        style={{ backgroundSize: open ? "100% cover" : "100% cover" }}
      >
        {/* <div className="battery_passport_raw_material_box" style={{backgroundSize:open?'cover':'cover'}}> */}
        <div className="battery_passport_raw_material_margin">
          {/*  <div className="battery_passport_raw_material battery_passport_message">
                    电池一般信息
                </div> */}
          <div className="battery_passport_message">
            {dictionariesData["Battery Raw Material Information"]}
          </div>
          <div className="battery_passport_message_underline"></div>
          <div>
            <div className="recovered_materials_table_name_box">
              <div className="recovered_materials_table_name">
                <p className="recovered_materials_table_materialName">
                  {dictionariesData["Recycled Content"]}
                </p>
                <p className="recovered_materials_table_proportion">
                  {dictionariesData["Percentage Share"]}
                </p>
              </div>
              <div className="recovered_materials_table_name">
                <p className="recovered_materials_table_materialName">
                  {dictionariesData["Recycled Content"]}
                </p>
                <p className="recovered_materials_table_proportion">
                  {dictionariesData["Percentage Share"]}
                </p>
              </div>
            </div>
            <div>
              {rawData?.rawTable?.map((item, idx) => {
                return (
                  <div className="recovered_materials_rawTable" key={idx}>
                    <p className="recovered_materials_materialName">
                      {item?.materialName}
                    </p>
                    <p className="recovered_materials_proportion">
                      {item?.proportion}
                    </p>
                  </div>
                );
              })}
            </div>
            <div className="battery_passport_view_more">
              <span>{dictionariesData["Waste Battery Management"]}</span>
              <img
                onClick={() => {
                  rawOpenTag();
                }}
                alt="img"
                src={ARROW_ICON}
                className={classnames("battery_passport_view_more_arrow", {
                  rotate180deg: rawOpen,
                })}
              />
            </div>
            {rawOpen && (
              <div>
                <p className="battery_explain_title">
                  {dictionariesData["Methods and Recommendations"]}
                </p>
                <p className="battery_explain_value">
                  {rawData?.methodsAndSuggestions}
                </p>
                <p className="battery_explain_title">
                  {dictionariesData["Practices for Separate"]}
                </p>
                <p className="battery_explain_value">
                  {rawData?.classifyWastePractices}
                </p>
                <p className="battery_explain_title">
                  {dictionariesData.WasteBattery}
                </p>
                <p className="battery_explain_value">
                  {rawData?.recycleInstructions}
                </p>
                <p className="battery_explain_title">
                  {dictionariesData["Safety Instructions"]}
                </p>
                <p className="battery_explain_value">
                  {rawData?.safetyInstructions}
                </p>
                <p className="battery_explain_title">
                  {dictionariesData["Meaning of Battery"]}
                </p>
                <p className="battery_explain_value">
                  {rawData?.labelAndSymbolMeaning}
                </p>
                <p className="battery_explain_title">
                  {dictionariesData["Impact of Hazardous Substances"]}
                </p>
                <p className="battery_explain_value">
                  {rawData?.harmfulImpact}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="battery_passport_ESG_box">
        <div className="battery_passport_ESG_margin">
          <div className="battery_passport_message">
            {dictionariesData["Battery ESG Information"]}
          </div>
          <div className="battery_passport_message_underline"></div>
          <div className="battery_passport_ESG_carbon mt-53r">
            <div className="battery_passport_ESG_carbon_box">
              <img className="battery_ESG_carbon_img" alt="img" src={ZJ_ICON} />
              <div className="battery_passport_ESG_carbon_flex">
                <p className="battery_passport_message_title">
                  {dictionariesData["Carbon Footprint of Battery"]}
                </p>
                <p className="">
                  <span className="battery_passport_ESG_carbon_footprintCarbon">
                    {relatedData?.footprintCarbon}
                  </span>
                  <span className="battery_passport_ESG_carbon_carbonUnit ml-11r">
                    {relatedData?.carbonUnit}
                  </span>
                </p>
              </div>
            </div>
            <Grid className="mt-58r" columns={2} gap={8}>
              <Grid.Item>
                <div className="battery_passport_message_title">
                  <img
                    alt="img"
                    src={YCL_ICON}
                    className="battery_passport_mini_icon "
                  />
                  {dictionariesData["Raw Material Processing"]}
                </div>
                <p className="battery_passport_ESG_carbon_carbonUnit mt-11r">
                  {relatedData?.acqAndTransStage}
                  <span className="ml-11r">{relatedData?.carbonUnit}</span>
                </p>
              </Grid.Item>
              <Grid.Item>
                <div className="battery_passport_message_title">
                  <img
                    alt="img"
                    src={SC_ICON}
                    className="battery_passport_mini_icon "
                  />
                  {dictionariesData["Main product production"]}
                </div>
                <p className="battery_passport_ESG_carbon_carbonUnit mt-11r">
                  {relatedData?.produceAndManufacturingStage}
                  <span className="ml-11r">{relatedData?.carbonUnit}</span>
                </p>
              </Grid.Item>
              <Grid.Item>
                <div className="battery_passport_message_title mt-53r">
                  <img
                    alt="img"
                    src={FX_ICON}
                    className="battery_passport_mini_icon "
                  />
                  {dictionariesData.Distribution}
                </div>
                <p className="battery_passport_ESG_carbon_carbonUnit mt-11r">
                  {relatedData?.distributionStage}
                  <span className="ml-11r">{relatedData?.carbonUnit}</span>
                </p>
              </Grid.Item>
              <Grid.Item>
                <div className="battery_passport_message_title mt-53r">
                  <img
                    alt="img"
                    src={MQ_ICON}
                    className="battery_passport_mini_icon"
                  />
                  {dictionariesData["End of life and recycling"]}
                </div>
                <p className="battery_passport_ESG_carbon_carbonUnit mt-11r">
                  {relatedData?.endStage}
                  <span className="ml-11r">{relatedData?.carbonUnit}</span>
                </p>
              </Grid.Item>
            </Grid>
          </div>
          <div
            className={classnames("responseProcurementImgList_box mt-32r", {
              procurement_img_width: languageEn,
            })}
          >
            <div className="responseProcurementImgList">
              <div className="responseProcurementImgList_title">
                {dictionariesData["Responsible Sourcing"]}
              </div>
              <div className="responseProcurementImgList_list">
                {relatedData?.responseProcurementImgList?.map((item, idx) => {
                  return (
                    <img
                      key={idx}
                      onClick={() => {
                        handleOpenLightbox();
                      }}
                      alt="img"
                      src={item}
                      className="responseProcurementimg"
                    />
                  );
                })}
              </div>
            </div>
            <Divider style={{ margin: 0 }} />
            <div className="responseProcurementImgList responseProcurementImgList_up">
              <div className="responseProcurementImgList_title">
                {dictionariesData["EU declaration of conformity"]}
              </div>
              <div className="responseProcurementImgList_list">
                {relatedData?.declarationOfEUImgList?.map((item, idx) => {
                  return (
                    <img
                      key={idx}
                      onClick={() => {
                        setResponseOpen(true);
                        // ImageViewer.Multi.show({
                        //   images: relatedData?.responseProcurementImgList,
                        //   defaultIndex: idx,
                        //   maxZoom: 10,
                        // });
                      }}
                      alt="img"
                      src={item}
                      className="responseProcurementimg"
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="battery_passport_chainList">
        <div className="battery_passport_ESG_margin">
          <div className="battery_passport_message">
            {dictionariesData.Traceability}
          </div>
          <div className="battery_passport_message_underline"></div>
          <p className="battery_chainList_stauts">
            * {dictionariesData["Current Status: Battery in Use"]}
          </p>
          <div className="table_scroll_hide">
            <div
              className={classnames("battery_status_scroll mt-11r", {
                tableEn: languageEn,
              })}
            >
              <div className="table_flex">
                {chainListData?.length > 0 && (
                  <MobileTable columns={columns} data={chainListData} />
                )}
              </div>
              <div className="table_content">
                <div className="table_content_scroll">
                  {chainListData?.length > 0 && (
                    <MobileTable columns={columnsTwo} data={chainListData} />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="data_center_logo">
        <Image src={LOGOICON} />
      </div>
    </div>
  );
}
